import clsx, { ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export const obj2url = (params: any) =>
  Object.entries(params).reduce(
    (prev, [key, value]) => (value ? prev + `&${key}=${value}` : prev),
    ""
  );
export const pageSizes = [
  { label: 10, value: 10 },
  { label: 20, value: 20 },
];
export const pageSizeNew = [10, 20, 30];
export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

export function convertStringSecondsToMinutesSeconds(
  secondsString: string
): string {
  const seconds = parseInt(secondsString, 10);

  if (isNaN(seconds)) {
    return "Nil"; // Handle invalid input as needed
  }

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const formattedSeconds =
    remainingSeconds < 10 ? `0${remainingSeconds}` : `${remainingSeconds}`;

  return `${formattedMinutes}:${formattedSeconds}`;
}
